import styled from "styled-components";

const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`

const StyledHeaderTitle = styled.span`
    color:  ${(props) => props.theme.primaryText};
    font-size: 1.1rem;
    font-weight: 600;
`

const StyledHeaderSubtitle = styled.span`
    color: ${(props) => props.theme.secondaryText};
    font-size: .8rem;
    font-weight: 500;
    margin: 0px;
`

const CustomHeaderTitleWithSub = (header: { title: string, subtitle?: React.ReactNode | string }) => {
    return <StyledHeaderContainer>
        <StyledHeaderTitle>{header.title}</StyledHeaderTitle>
        {header.subtitle && <StyledHeaderSubtitle>{header.subtitle}</StyledHeaderSubtitle>}
    </StyledHeaderContainer>
}

export default CustomHeaderTitleWithSub;